/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_Needs_AttentionInputs */

const en_metric_needs_attention = /** @type {(inputs: Metric_Needs_AttentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Needs Attention`)
};

const es_metric_needs_attention = /** @type {(inputs: Metric_Needs_AttentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Necesitan atencion`)
};

/**
* | output |
* | --- |
* | "Needs Attention" |
*
* @param {Metric_Needs_AttentionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const metric_needs_attention = /** @type {((inputs?: Metric_Needs_AttentionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Needs_AttentionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_metric_needs_attention(inputs)
	return es_metric_needs_attention(inputs)
});